module.exports = __webpack_public_path__ + "img/logo-top.4e012d5c.svg";